<template>
  <div class="overflow-x-auto scrollbar-none">
    <PlpContainer class="w-auto" :is-wide>
      <ul class="flex gap-8 md:gap-16">
        <li
          v-for="criterion in criteria"
          :key="criterion.criterion"
          class="w-[288px] shrink-0"
        >
          <FinderCard :title="criterion.title" />
        </li>
      </ul>
    </PlpContainer>
  </div>
</template>

<script lang="ts" setup>
import type {
  Facet,
  UiPriceFacet,
} from '@backmarket/nuxt-layer-recommendation/filtering/types'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import PlpContainer from '../PlpContainer/PlpContainer.vue'

import { getFinderCriteria } from './Finder.utils'
import FinderCard from './components/FinderCard/FinderCard.vue'

/**
 * Props required by the upcoming filter-selection feature.
 *
 * They are accepted (and passed through from `ProductListPage.vue`) today so
 * that the wiring is in place; the component does not use them yet and the
 * feature lands as a pure component-internal change later.
 */
defineProps<{
  facets?: Facet[]
  priceFacet?: UiPriceFacet
  filtersInput?: Record<string, string[]>
  priceInput?: [number, number]
}>()

const i18n = useI18n()

const criteria = getFinderCriteria(i18n)

const experiments = useExperiments()
const isWide =
  experiments['experiment.plpWideContainer'] === 'withWideContainer'
</script>
